import os from '@edu-fe/os'
import login from '@/utils/login'
import assign from 'lodash.assign'
import api from '../../lib/api/index'
import SignInfo from '../../lib/signInfo'

const name = 'vip'

export default {
  name,
  namespaced: true,
  state () {
    return {
      userName: '',
      userPic: '',
      signStatus: 0,
      cardList: [],
      bonus: 0,
      courses: [],
      isBuy: 0,
      endDate: 0,
      isFilterMonthVip: 0
    }
  },
  getters: {},
  mutations: {
    set (state, data) {
      assign(state, data)
    }
  },
  actions: {
    async getPrivilegeDetail ({ commit, state }) {
      await SignInfo.getPrivilegeDetail()
      const info = SignInfo.state
      commit('set', info)
    },
    async getCourses ({ commit }) {
      const { data } = await api.privilege.getCourses()
      data.map((val) => {
        val.name = val.title
      })
      commit('set', { courses: data })
    },
    async checkLogin () {
      const wpsSid = await login.getWpsSid()
      return wpsSid || login.login()
    },
    async getBonus ({ commit, state }) {
      const { data = {} } = await api.wealth.getWealthData(state.cardList[1].courseId)()
      commit('set', { bonus: data.balance })
    },
    async init ({ dispatch, rootState }) {
      if (!rootState.vipOperationList.length) {
        dispatch('getPrivilege', null, { root: true })
      }
      await dispatch('getPrivilegeDetail')
      dispatch('getBonus')
      if (os.type === 'app') {
        if (os.name === 'android' || os.name === 'ios') {
          return
        }
      }
      await dispatch('checkLogin')
    }
  }
}
